import PrivacyPolicy from "../../components/legal/privacy/PrivacyPolicy.tsx";

function PrivacyPolicyPage() {
    return (
        <PrivacyPolicy />
    )
}

export default PrivacyPolicyPage;